import Home from "@/routes/Home";
import { InitialLoading } from "@/routes/InitialLoading";
import { Onboarding } from "@/routes/Onboarding";
import { AuthProvider, useAuth } from "./providers/auth-provider";
import { UserProvider, useUser } from "./providers/user-provider";
import { SPAProvider } from "./providers/spa-provider";
import { DuelProvider } from "./providers/duel-provider";
import { RaidProvider } from "./providers/raid-provider";
import { TelegramGuard } from "./components/telegram-guard";

function RootRouter() {
  const { state: userState } = useUser();
  const { state: authState } = useAuth();

  if (authState.status === "unauthorized_environment") {
    return <TelegramGuard />;
  }

  // Show loading screen while auth or user profile is loading
  if (userState.status === "idle" || userState.status === "loading") {
    return <InitialLoading />;
  }

  // Redirect to onboarding if user is not registered
  if (
    userState.status === "not_registered" ||
    userState.status === "onboarding_in_progress"
  ) {
    return <Onboarding />;
  }

  // Default to Home if loaded or even if there's an error (Home can handle error state if needed)
  return <Home />;
}

export default function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <SPAProvider>
          <DuelProvider>
            <RaidProvider>
              <div className="min-h-screen w-full bg-pk-night-2 flex items-center justify-center text-white relative">
                <RootRouter />
              </div>
            </RaidProvider>
          </DuelProvider>
        </SPAProvider>
      </UserProvider>
    </AuthProvider>
  );
}
